import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToTop } from "../util/functions";
import { INSTRUCTIONS_ROUTE } from "../util/constants";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith(`${INSTRUCTIONS_ROUTE}/`)) {
      scrollToTop(0, "instant");
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
